import {Component, Object3D} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {CursorTarget} from '@wonderlandengine/components';
import type {GameAnalytics as GA} from 'gameanalytics';
declare var GameAnalytics: typeof GA;
import {PaintballClient} from './paintball-client.js';

/**
 * start-game-button
 */
export class StartGameButton extends Component {
    static TypeName = 'start-game-button';

    /* Properties that are configurable in the editor */

    @property.object({required: true})
    clientObject!: Object3D;

    start() {
        this.object.getComponent(CursorTarget)!.onClick.add(this.onClick);
    }

    onClick = () => {
        this.clientObject.getComponent(PaintballClient)!.startGame();
        GameAnalytics.addDesignEvent('button:start-game');
    };
}
